import React, { useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Modal,
  Box,
  MenuItem,
} from "@mui/material";

const CATEGORY_OPTIONS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
  "Other",
];
const LANGUAGE_OPTIONS = ["English", "Spanish"];

const EditCampaignModal = ({ open, campaign, onClose, onSave }) => {
  const [name, setName] = useState(campaign.name || "");
  const [description, setDescription] = useState(campaign.description || "");
  const [category, setCategory] = useState(campaign.category || "");
  const [language, setLanguage] = useState(campaign.language || "");

  const handleUpdateCampaign = () => {
    const updatedCampaign = {
      ...campaign,
      name,
      description,
      category,
      language,
    };
    onSave(updatedCampaign);
  };

  return (
    //  {/* Edit Campaign Modal */}
    <div>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            width: 400,
            margin: "auto",
            padding: 3,
            marginTop: 8,
            backgroundColor: "white",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6">Edit Campaign</Typography>

          <TextField
            fullWidth
            label="Campaign Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ my: 2 }}
          />

          <TextField
            fullWidth
            label="Description"
            variant="outlined"
            multiline
            minRows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ my: 2 }}
          />

          <TextField
            select
            fullWidth
            label="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            sx={{ my: 2 }}
          >
            {CATEGORY_OPTIONS.map((d) => (
              <MenuItem key={d} value={d}>
                {d}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="Language"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            sx={{ my: 2 }}
          >
            {LANGUAGE_OPTIONS.map((l) => (
              <MenuItem key={l} value={l}>
                {l}
              </MenuItem>
            ))}
          </TextField>

          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateCampaign}
            sx={{ mr: 1 }}
          >
            Save
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default EditCampaignModal;